import type { RouteLocation } from 'vue-router';
import { useOrganizationsStore } from '@/stores/organizations';
import { displayError } from '@/utils/displayError';
import { i18n } from '@/i18n';

export const checkIsOrgExists = async (route: RouteLocation) => {
  const organizationsStore = useOrganizationsStore();
  const { organizationId } = route.params;

  if (organizationsStore.organization?.id !== organizationId) {
    try {
      await organizationsStore.getOrganization(organizationId as string);
    } catch (error: any) {
      if (error.response.status === 404) {
        displayError([i18n.global.t('orgDoesNotExist')]);

        return {
          name: 'organizations',
        };
      }
    }
  }
};
